export const coerceUTCDateString = (date: string) =>
  date.toLowerCase().indexOf('z') >= 0 ? date : `${date}Z`;
